var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"meter",staticStyle:{"width":"100%","height":"100%","background-color":"black"}})
}
var staticRenderFns = []

export { render, staticRenderFns }